import { Input, Select, Form } from "antd";
import "./sale-add-item.css";
import { DeleteOutlined } from "@ant-design/icons";
import { ftmPrice } from "../../extensions/utils";
import { isMobile } from "@/extensions/design";

const userOptionsWithPosition = (users) => (users ?? []).map(u => ({
  value: u.value,
  label: (
    <div>
      <div>{u.name ?? u.label}</div>
      {u.position && <div style={{ fontSize: "12px", color: "#999" }}>{u.position}</div>}
    </div>
  ),
  title: u.name ?? u.label,
}));

const SaleAddItem = ({ item, idx, onChange, onDelete, users }) => {
  const userOptions = userOptionsWithPosition(users);

  console.log(item)
  const onValueChange = value => {
    const newItem = {...item, ...value};
    newItem.syma = Number(newItem.price) * Number(newItem.qty) * Number((1 - newItem.discountPrc / 100)) || 0;
    onChange(newItem, idx)
  }

  return !isMobile ? (item ?
    <><div className="sale-add-item-line">
      <div>{item.productName}<DeleteOutlined onClick={() => onDelete(idx)} className="sale-add-item-del"/></div>
      <div><Select style={{width: "100%"}} options={userOptions} optionLabelProp="title" onChange={e => onValueChange({userId: e}) } disabled={item?.vid === 4}/></div>
      <div>{item.expUnit}</div>
      <div><Input value={item.price} onChange={e => onValueChange({price: e.target.value}) } /></div>
      <div><Input value={item.discountPrc} onChange={e => onValueChange({discountPrc: e.target.value}) } /></div>
      <div><Input value={item.qty} onChange={e => onValueChange({qty: e.target.value}) } /></div>
      <div className="ta-right">{ftmPrice(item.syma)}</div>
    </div>
    {item.vid === 0 && item.storeQty < Number(item.qty) && <div style={{color: "red"}}>Недостаточно товара. Остаток на складе {item.storeQty} {item.expUnit}</div>}
    </> :
    <div className="sale-add-item-line sale-add-item-header">
      <div>Наименование</div>
      <div>Исполнитель</div>
      <div>Ед.</div>
      <div>Цена</div>
      <div>Скидка %</div>
      <div>Кол.</div>
      <div>Сумма</div>
    </div>
  ) : (<>
    <div className="sale-add-item-row sale-add-item-row-with-delete">
      <div className="sale-add-item-input-group">
        <label className="sale-add-item-label">Наименов.</label>
        <Input value={item.productName} disabled className="sale-add-item-input" />
      </div>
      <DeleteOutlined className="sale-add-item-delete-icon" onClick={() => onDelete(idx)}/>
    </div>
  
    <div className="sale-add-item-row">
      <label className="sale-add-item-label">Исполн.</label>
      <Select
        options={userOptions}
        optionLabelProp="title"
        onChange={(e) => onValueChange({ userId: e })}
        className="sale-add-item-input"
        disabled={item?.vid === 4}
      />
    </div>

    <div className="sale-add-item-row sale-add-item-row-gap-large">
      <div className="sale-add-item-input-group">
        <label className="sale-add-item-label">Ед. изм.</label>
        <Input value={item.expUnit} disabled />
      </div>
  
      <div className="sale-add-item-input-group sale-add-item-input-group-price">
        <label className="sale-add-item-label">Цена</label>
        <Input type="number" value={item.price} onChange={(e) => onValueChange({ price: e.target.value })}/>
      </div>
    </div>
  
    <div className="sale-add-item-row sale-add-item-row-gap-large">
      <div className="sale-add-item-input-group sale-add-item-input-group-double">
        <label className="sale-add-item-label">Скидка %</label>
        <Input type="number" value={item.discountPrc} onChange={(e) => onValueChange({ discountPrc: e.target.value })}/>
      </div>
  
      <div className="sale-add-item-input-group sale-add-item-input-group-onehalf sale-add-item-input-group-gap-small">
        <label className="sale-add-item-label sale-add-item-label-min-width">Кол-во</label>
        <Input type="number" value={item.qty} onChange={(e) => onValueChange({ qty: e.target.value })}/>
      </div>
  
      <div className="sale-add-item-input-group sale-add-item-input-group-double">
        <label className="sale-add-item-label sale-add-item-label-min-width">Сумма</label>
        <Input value={ftmPrice(item.syma)} disabled />
      </div>
    </div>
    {item.vid === 0 && item.storeQty < Number(item.qty) && (
      <div className="sale-add-item-error">
        Недостаточно товара. Остаток на складе {item.storeQty} {item.expUnit}
      </div>
    )}
    <div className="sale-add-item-divider" />
  </>
  )
}

export default SaleAddItem;